import { render, staticRenderFns } from "./editOwnerInvoice.vue?vue&type=template&id=46274de2"
import script from "./editOwnerInvoice.vue?vue&type=script&lang=js"
export * from "./editOwnerInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports